// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__WLmpM","large":"styles_large__3EsOG"};